import React from 'react';
import { Card, CardActions } from 'react-toolbox/lib/card';
import { connect } from 'react-redux';
import { Button } from 'react-toolbox/lib/button';

import Input from 'react-toolbox/lib/input';
import Dropdown from 'react-toolbox/lib/dropdown';

import { list, getGroups } from '~/actions/customerGroups';
import dynamicSort from '~/utils/dynamicSort';
import Styles from './users.scss';

import DistributorItem from './Distributor';

const orderByStates = [
  { value: 'Name', label: 'Name' },
  { value: '-Name', label: 'Name (desc)' }
];

class Distributor extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired
  };
  constructor(props) {
    super(props);
    this.state = {
      orderBy: '-Name',
      search: ''
    };
    this.typeTimer = null;
  }
  componentDidMount() {
    list(this.props.dispatch, this.context.apiClient);
  }
  fetchFrom3dCart() {
    getGroups(this.props.dispatch, this.context.apiClient);
  }

  renderGroups(listAr) {
    const { search } = this.state;
    const seekRegex = new RegExp(search, 'i');

    return listAr.map(item => {
      if (seekRegex.exec(item.Name)) {
        return (
          <DistributorItem distributor={item} key={item.CustomerGroupID} />
        );
      }
      return false;
    });
  }
  render() {
    const listOfGroups = (this.props.list && this.props.list.toJS()) || false;
    listOfGroups.sort(dynamicSort(this.state.orderBy));
    return (
      <div className={Styles.content}>
        <div className={Styles.actionBar}>
          <div className={Styles.searchBox}>
            <Input
              type="text"
              label="Search"
              icon="search"
              value={this.state.search}
              onChange={e => this.setState({ search: e })}
            />
          </div>
          <div className={Styles.actionBox}>
            <Dropdown
              label="Order by"
              auto
              onChange={orderBy => this.setState({ orderBy })}
              source={orderByStates}
              value={this.state.orderBy}
            />
          </div>
        </div>

        <div className={Styles.cardBox}>
          <Card>
            <div className={Styles.orderTitle}>Customer groups</div>
            <table className={Styles.table}>
              <thead>
                <tr>
                  <th>
                    <div className={Styles.spacer} />
                  </th>
                  <th>Name</th>
                  <th>Distributor?</th>
                </tr>
              </thead>
              <tbody>{listOfGroups && this.renderGroups(listOfGroups)}</tbody>
            </table>
            <CardActions>
              <Button
                icon="cached"
                label="Refetch list from 3dcart"
                primary
                onClick={() => {
                  this.fetchFrom3dCart();
                }}
              />
            </CardActions>
          </Card>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  list: state.getIn(['customerGroups', 'list'], {})
});

// Setting pure: false is required for react router to work
export default connect(mapStateToProps)(Distributor);



// WEBPACK FOOTER //
// ./app/pages/Distributor/index.js